import { useState } from "react";
import { ResponsiveContainer, ComposedChart, Bar, Line, XAxis, YAxis, Tooltip, CartesianGrid } from "recharts";
import { formatKr, formatKrWhole } from "../../lib/format";

const GRAN = { day: "pr. dag", week: "pr. uge", month: "pr. måned" };

function Tip({ active, payload, showPrev }) {
  if (!active || !payload?.length) return null;
  const b = payload[0].payload;
  return (
    <div className="st-tip" data-testid="stats-chart-tooltip">
      <b>{b.full}</b>
      <span>Omsætning <strong>{formatKr(b.v)}</strong></span>
      <span>Udleveret <strong>{b.q} stk.</strong></span>
      {showPrev && b.pv != null && <span className="muted">Forrige periode {formatKr(b.pv)}</span>}
    </div>
  );
}

export default function StatsChart({ data, gran }) {
  const [showPrev, setShowPrev] = useState(false);
  const empty = !data.some((b) => b.v > 0);
  const every = Math.max(0, Math.ceil(data.length / 8) - 1);
  return (
    <section className="panel st-chart" data-testid="stats-chart">
      <div className="st-panel-head">
        <h2>Omsætning {GRAN[gran]}</h2>
        <label className="st-check">
          <input type="checkbox" checked={showPrev} onChange={(e) => setShowPrev(e.target.checked)} data-testid="stats-chart-prev-toggle" />
          Vis forrige periode
        </label>
      </div>
      <div className="st-chart-box" data-testid={`stats-chart-${gran}`}>
        {empty && <p className="st-chart-empty" data-testid="stats-chart-empty">Ingen omsætning i perioden</p>}
        <ResponsiveContainer width="100%" height={240}>
          <ComposedChart data={data} margin={{ top: 8, right: 4, left: 0, bottom: 0 }}>
            <CartesianGrid vertical={false} stroke="var(--line)" strokeDasharray="3 4" />
            <XAxis dataKey="label" tickLine={false} axisLine={false} interval={every} tick={{ fontSize: 11, fill: "var(--muted)" }} />
            <YAxis width={44} tickLine={false} axisLine={false} tick={{ fontSize: 11, fill: "var(--muted)" }}
              tickFormatter={(v) => formatKrWhole(v)} allowDecimals={false} />
            <Tooltip content={<Tip showPrev={showPrev} />} cursor={{ fill: "rgba(15,107,75,.06)" }} />
            <Bar dataKey="v" fill="var(--green)" radius={[5, 5, 0, 0]} maxBarSize={36} animationDuration={500} />
            {showPrev && (
              <Line dataKey="pv" type="monotone" stroke="var(--muted)" strokeOpacity={0.55} strokeDasharray="4 4" dot={false} strokeWidth={2} />
            )}
          </ComposedChart>
        </ResponsiveContainer>
      </div>
      <p className="st-chart-legend">
        <span className="dot g" /> Denne periode
        {showPrev && <><span className="dot p" /> Forrige periode</>}
      </p>
    </section>
  );
}
